import { isCPFValid } from "@/utils/FormValidators";

/**
 * Documento do paciente (antes vuelidate no DocumentInput): CPF válido, ou, para quem mora fora,
 * qualquer documento com 3+ caracteres. Devolve a primeira mensagem de erro, ou `null`.
 */
export function documentError(value: string, foreigner: boolean): string | null {
  if (foreigner) return !value || value.length < 3 ? "Informe um documento" : null;
  if (!value) return "Informe um CPF para o recibo";
  return isCPFValid(value) ? null : "Informe um CPF válido";
}

export const CPF_MASK = "###.###.###-##";
// documento estrangeiro: qualquer caractere (como antes)
export const FOREIGN_DOCUMENT_MASK = "************************";

export const onlyDigits = (v: string) => (v || "").replace(/\D/g, "");

/** "00000000191" → "000.000.001-91" (aceita parcial, enquanto digita). */
export function formatCpf(v: string) {
  const d = onlyDigits(v).slice(0, 11);
  return d
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2");
}

/** Valor que vai para a API: CPF só com números; documento estrangeiro como foi digitado. */
export const documentValue = (v: string, foreigner: boolean) => (foreigner ? v : onlyDigits(v));
